import { Link, useLocation } from "react-router-dom";
import React, { useState, useEffect } from 'react';
import "./SideNav.css";

const SideNav = ({ isExpanded, onToggle }) => {
  const location = useLocation();
  const [isHovered, setIsHovered] = useState(false);
  const [SideNavData, setSideNavData] = useState([]);
  const handleMouseEnter = () => setIsHovered(true);
  const handleMouseLeave = () => setIsHovered(false);
  const sidebarWidth = isExpanded || isHovered ? '200px' : '60px';

  useEffect(() => {
    const intervalId = setInterval(() => {
      const adminSideNav = localStorage.getItem('menuData');
      if (adminSideNav) {
        try {
          const parsed = JSON.parse(adminSideNav);
          if (Array.isArray(parsed)) {
            setSideNavData(parsed);
            clearInterval(intervalId); // ✅ Stop polling once data is found and set
          } else {
            console.error('menuData is not an array');
          }
        } catch (e) {
          console.error('Invalid JSON in menuData:', e);
        }
      }
    }, 500);

    return () => clearInterval(intervalId);
  }, []);

  // const adminSideNav = [
  //   { name: "Dashboard", path: "dashboard", id: 1, icon: "bi-house-door-fill" },
  //   { name: "Banner", path: "banners", id: 2, icon: "bi-layout-text-window" },
  //   { name: "About Us", path: "aboutus", id: 3, icon: "bi-info-circle-fill" },
  //   { name: "Project", path: "project", id: 5, icon: "bi-clipboard-check" },
  //   { name: "Publication", path: "publication", id: 6, icon: "bi-journal-bookmark-fill" },
  //   { name: "Gallery", path: "gallery", id: 7, icon: "bi-images" },
  //   { name: "News", path: "news", id: 8, icon: "bi-newspaper" },
  //   { name: "Contacted People", path: "contactus", id: 9, icon: "bi-telephone-fill" },
  //   { name: "Events", path: "eventlist", id: 10, icon: "bi-calendar-event" },
  //   { name: "User List", path: "userlist", id: 11, icon: "bi-person-lines-fill" },
  //   { name: "CMS User", path: "admin-control", id: 12, icon: "bi-people-fill" },
  //   { name: "User Rights", path: "setting", id: 13, icon: "bi-gear-fill" }
  // ];
  return (
    <div className='sides' onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      style={{ width: sidebarWidth }}
    >
      <div style={{ marginBottom: '1rem', marginLeft: '8px' }}>
        <button onClick={onToggle}
          style={{ background: 'none', border: 'none', color: 'white' }}>
          ☰
        </button>
      </div>
      <nav className="mb-5">
        <ul className="sidebar-list">
          {SideNavData?.length && SideNavData?.map((link) => (
            <Link to={link.path} key={link.id} style={{ textDecoration: 'none', color: 'inherit' }}>
              <li className={location?.pathname?.includes(link?.path) ? "active" : ""}>
                <i className={`bi ${link.icon}`} style={{ color: isExpanded ? 'orange' : 'inherit' }}></i>
                {(isExpanded || isHovered) && <span style={{ marginLeft: "8px" }}>{link.name}</span>}
              </li>
            </Link>
          ))}
        </ul>
      </nav>
    </div>
  );
};

export default SideNav;
